import { NotificationRuleBaseDto } from './notification-rule-base-dto';

export class NotificationRuleWorkItemCreateDto extends NotificationRuleBaseDto {
  clientIds: number[];
  processNodeIds: string[];
  statuses: number[];
}
